


























































































































































































import Vue, { PropType } from 'vue';
import Logo from '../Logo';
import Icon from '../Icon';
import PipelineMenuItemPosition from './PipelineMenuItemPosition.vue';
import Button from '../Button/Button.vue';

interface PipelineItem {
  title: string;
  steps: string[];
  childrenActive: boolean;
  children: { title: string; steps: string[]; hidden?: boolean }[];
}

export default Vue.extend({
  components: { Logo, Icon, PipelineMenuItemPosition, Button },
  props: {
    collapsed: {
      type: Boolean,
      default: false,
    },
    currentStep: {
      type: String,
      required: true,
    },
    pipelineItems: {
      type: Array as PropType<PipelineItem[]>,
      required: true,
    },
    stepHistory: {
      type: Array as PropType<string[]>,
      required: true,
    },
    smallMobileItems: {
      type: Boolean,
      default: false,
    },
    withFooterButton: {
      type: Boolean,
      default: false,
    },
    footerButtonText: {
      type: String,
      required: false,
    },
    footerButtonIcon: {
      type: String,
      required: false,
    },
    footerButtonMobileOnly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      items: this.pipelineItems as PipelineItem[],
      showSideMenuMobile: false,
      hasScroll: false,
    };
  },
  watch: {
    pipelineItems(value) {
      this.items = value;
    },
  },
  computed: {
    cssVars() {
      return {
        '--items-offset': this.smallMobileItems ? '16px' : '32px',
        '--top-justify': this.smallMobileItems ? 'center' : 'flex-start',
      };
    },
  },
  mounted() {
    window.addEventListener('scroll', this.setHasScroll);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.setHasScroll);
  },
  methods: {
    goToStep(steps: string[]) {
      this.$emit('goToStep', steps[0]);
    },
    isCurrentStep(steps: string[]): boolean {
      return steps.includes(this.currentStep);
    },
    isDropDownEnabled(index: number): boolean {
      const item = this.items[index];
      const hasChildren = item.children.length > 0;
      const isStepVisited = this.isStepVisited(item.steps, false);
      const isCurrentStep = this.isCurrentStep(item.steps);

      return (
        hasChildren && isStepVisited && !item.childrenActive && !isCurrentStep
      );
    },
    isDropUpEnabled(index: number): boolean {
      const item = this.items[index];
      const hasChildren = item.children.length > 0;
      const isCurrentStep = this.isCurrentStep(item.steps);

      return hasChildren && (item.childrenActive || isCurrentStep);
    },
    isStepVisited(steps: string[], strict: boolean = true): boolean {
      const arrayFn = strict ? 'every' : 'some';
      return steps[arrayFn]((step) => this.stepHistory.includes(step));
    },
    toggleChildren(index: number, active: boolean) {
      if (this.isCurrentStep(this.items[index].steps)) return;

      this.items[index].childrenActive = active;
    },
    setHasScroll() {
      this.hasScroll = window.scrollY > 0;
    },
    toggleSideMenuMobile() {
      this.showSideMenuMobile = !this.showSideMenuMobile;
    },
    onFooterButtonClick() {
      this.$emit('onFooterButtonClick');
    },
  },
});
